import {
  masterParamPayloadSchema,
  MasterParamPayloadSchema,
  useMasterParam,
} from "@/api/master-param";
import { FormContainer } from "@/components/form/form-container";
import { Loading } from "@/components/ui/loading";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { MasterParamFormFields } from "./MasterParamFormFields";
import { Anchor } from "@/components/ui/anchor";

export function MasterParamDetailForm({ id }: { id: string }) {
  const {
    data: masterParam,
    isPending: isLoadingData,
    isError,
  } = useMasterParam({ id });

  const form = useForm<MasterParamPayloadSchema>({
    resolver: zodResolver(masterParamPayloadSchema),
    defaultValues: {
      paramType: masterParam?.paramType,
      paramTag: masterParam?.paramTag,
      active: masterParam?.active,
      value: masterParam?.value,
      value2: masterParam?.value2,
      description: masterParam?.description,
    },
    values: {
      paramType: masterParam?.paramType ?? "",
      paramTag: masterParam?.paramTag ?? "",
      active: masterParam?.active ? "true" : "false",
      value: masterParam?.value ?? "",
      value2: masterParam?.value2 ?? "",
      description: masterParam?.description || "-",
    },
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!masterParam) {
    return <div>Master Param not found</div>;
  }

  if (isError) {
    return <div>Failed to load master param</div>;
  }

  return (
    <FormContainer form={form}>
      <MasterParamFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/master-param" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
